export const PRODUCT_ACTIVE_REVIEW = {
    _id: '',
    email: '',
    username: '',
    comment: '',
    rating: 5,
    images: []
};